// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"buttonWrapper--IAabT","button":"button--j3v04","large":"large--qy4z8","full":"full--g9vvx","center":"center--YdvvY","loader":"loader--WPuzk"};